import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Table } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import trash from "./../../Assets/Images/trash.png";
import Modal from "antd/es/modal/Modal";
import {
  formatDate,
  numberFormat,
  toastStyle,
  refreshPage,
  getTodayDateISO,
  dateFormat,
  formatTime,
  getType,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import {
  getTransfer,
  recordTransferAction,
} from "../../Helpers/apiCalls/Inventory/TransferApi";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import { validateTransferView } from "../../Helpers/Validation/Inventory/TransferValidation";
import InputError from "../../Components/InputError/InputError";
import TransferModal from "./Transfer/TransferModal";
import Moment from "moment";
import cleanLogo from "../../Assets/Images/Login/transparent_bg.png";
import { getGatePass } from "../../Helpers/apiCalls/Inventory/GatePassApi";
import noDataImg from "../../Assets/Images/no-data-img.png";
import Footer from "../../Components/Footer/Footer";

export default function ViewTransfer() {
  const { id, type } = useParams();
  let navigate = useNavigate();

  const [inactive, setInactive] = useState(true);
  const [isSet, setIsSet] = useState(false);
  const [items, setItems] = useState([]);
  const [newTransfer, setNewTransfer] = useState({
    transfer_date: "",
    branch_from: "",
    branch_from_name: "",
    encoded_by: "",
    branch_to: "",
    branch_to_name: "",
    remarks: "",
  });
  const [itemData, setItemData] = useState([]);
  const [gatePassDetails, setGatePassDetails] = useState({});
  const [gatePassItem, setGatePassItem] = useState([]);
  const [additionalItemData, setAdditionalItemData] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeValue, setEmployeeValue] = useState({
    name: "dispatcher",
    label: "",
    value: "",
  });

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    transfer_number: false,
    dispatcher: false,
  });

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false);
  const handleShowPrintModal = () => setShowPrintModal(true);
  const handleClosePrintModal = () => setShowPrintModal(false);
  const [fileList, setFileList] = useState([]);
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState("");

  /* approve modal handler */
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleShowApprovalModal = () => {
    if (validateTransferView(newTransfer, items, setIsError)) {
      setShowApprovalModal(true);
    } else {
      handleCloseApprovalModal();
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  };
  const handleCloseApprovalModal = () => setShowApprovalModal(false);

  async function handlePrintPI() {
    toast.loading("Printing Transfer Details", { style: toastStyle() });
    handleClosePrintModal();
    setTimeout(() => {
      toast.dismiss();
      Print();
    }, 1000);
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print(printContents);
    document.body.innerHTML = originalContents;
    refreshPage();
  }

  function handleDetailChange(e) {
    const { name, value } = e.target;
    const newList = newTransfer;
    newList[name] = value;
    setNewTransfer(newList);
  }

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = newTransfer;
    newList[e.name] = e.value;
    setNewTransfer(newList);

    if (e.name === "dispatcher")
      setEmployeeValue({ name: e.name, label: e.label, value: e.value });
  }

  async function fetchTransfer() {
    setFileList([])
    setNewTransfer([])
    const response = await getTransfer(id);

    if (response.data) {
      var data = response.data.data[0];
      setNewTransfer({
        transfer_number: data.transfer_number,
        doc_no: data.id,
        encoded_by_id: data.added_by,
        encoded_by: data.added_by_name,
        encoded_on: Moment(data.added_on).format("MMM DD, YYYY"),
        transfer_date: Moment(data.transfer_date).format("MMM DD, YYYY"),
        dispatcher: data.dispatcher > 0 ? data.dispatcher : "",
        dispatcher_id: data.dispatcher,
        dispatcher_name: data.dispatcher_name,
        branch_to: data.branch_to,
        branch_from: data.branch_from,
        branch_to_name: data.branch_to_name,
        branch_from_name: data.branch_from_name,
        remarks: data.remarks,
        added_by_name: data.added_by_name,
        added_by_name_signature: data.added_by_name_signature,
        approved_by_name: data.approved_by_name,
        approved_by_name_signature: data.approved_by_name_signature,

        received_date: data.completed_on
          ? data.completed_on.split(" ")[0]
          : "N/A",
        received_by_id: data.completed_by,
        received_by: data.completed_by_name,
      });
      setEmployeeValue({
        name: "dispatcher",
        label: data.dispatcher_name,
        value: data.dispatcher,
      });
      var additionals = data.transfer_receive_items.map((item) => {
        var info = item;
        info.item_name = `${item.item_name} (Additional)`;
        return info;
      });
      var itemEntries = data.transfer_items.concat(additionals);
      setItemData(data.transfer_items);
      setAdditionalItemData(itemEntries);

      setFileList(response.data.data[0].transfer_attachments);
      setIsSet(true);
    }
  }

  async function fetchGatePass() {
    const response = await getGatePass("", id);

    if (response.data) {
      var data = response.data.data;
      setGatePassDetails(data)
      // setIsSet(true);
    }
  }

  //API CALL
  async function fetchAllEmployees() {
    const response = await getAllEmployees();
    if (response.data.data) {
      var employeesList = response.data.data;
      employeesList.map((employee) => {
        var info = {};

        info.name = "dispatcher";
        info.label = employee.first_name + " " + employee.last_name;
        info.value = employee.id;

        setEmployeeOptions((prev) => [...prev, info]);
      });
    }
  }

  function handleApproveTransfer() {
    handleRecordStatusApproved();
  }

  async function handleRecordStatusApproved() {
    const response = await recordTransferAction(newTransfer, "approved");
    if (response.data) {
      toast.success(response.data.message, { style: toastStyle() });
      setTimeout(() => {
        handleCloseApprovalModal();
      }, 1000);
      navigate("/transfers");
      // navigate("/gatepass/add/" + newTransfer.doc_no);
    } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
    }
  }

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(id) {
    const rowId = id;
    const newItemList = [...itemData];
    newItemList.splice(rowId, 1);
    setItemData(newItemList);
  }

  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            {type == "completed" || type == "incomplete" && <th>Received Qyt</th>}
            {type == "completed" || type == "incomplete" && <th>Remaining Qty</th>}
            <th>Unit</th>
            {type !== "completed" && type !== "processed"  && type !== "incomplete" && type !== "pending" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {isSet
            ? itemData.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td className="franchise-td-gray">{item.item_name}</td>
                    <td className="franchise-td-gray">
                      {numberFormat(item.qty)}
                    </td>
                    {type == "completed" || type == "incomplete" && 
                      (
                        <>
                        <td className="franchise-td-gray">
                          {numberFormat(item.received_qty)}
                        </td>
                        <td className="franchise-td-gray">
                          {numberFormat(item.remaining_qty)}
                        </td>
                        </>
                      )
                    }
                    <td className="franchise-td-gray">{item.unit}</td>
                    {type !== "completed" && type !== "processed" && type !== "incomplete" && type !== "pending" && (
                      <td>
                        <img
                          alt="delete"
                          src={trash}
                          onClick={() => handleRemoveItem(index)}
                          className="cursor-pointer"
                        />
                      </td>
                    )}
                  </tr>
                );
              })
            : ""}
        </tbody>
      </Table>
    );
  }

  function renderGatePassTable(data) {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Description</th>
            <th>Consignment No.</th>
          </tr>
        </thead>
        <tbody>
          {/* {isSet */}
            {/* ? gatePassItem.map((item, index) => { */}
            {data?.gate_pass_items.map((item) => {
                return (
                  <tr key={item.id}>
                    <td className="franchise-td-gray">
                      {numberFormat(item.qty)}
                    </td>
                    <td className="franchise-td-gray">{item.unit}</td>
                    <td className="franchise-td-gray">{item.description}</td>
                    <td className="franchise-td-gray">{item.consignment_no}</td>
                  </tr>
                );
              })}
            {/* : ""} */}
        </tbody>
      </Table>
    );
  }

  function renderRequestTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {isSet
            ? itemData.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td className="franchise-td-gray">{item.item_name}</td>
                    <td className="franchise-td-gray">
                      {numberFormat(item.qty)}
                    </td>
                    <td className="franchise-td-gray">{item.unit}</td>
                  </tr>
                );
              })
            : ""}
        </tbody>
      </Table>
    );
  }

  function renderReceivedItemsTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            {type !== "completed" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {isSet
            ? additionalItemData.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td className="franchise-td-gray">{item.item_name}</td>
                    <td className="franchise-td-gray">
                      {numberFormat(item.received_qty)}
                    </td>
                    <td className="franchise-td-gray">{item.unit}</td>
                    {type !== "completed" && (
                      <td>
                        <img
                          alt="delete"
                          src={trash}
                          onClick={() => handleRemoveItem(index)}
                          className="cursor-pointer"
                        />
                      </td>
                    )}
                  </tr>
                );
              })
            : ""}
        </tbody>
      </Table>
    );
  }

  useEffect(() => {
    fetchTransfer();
    fetchAllEmployees();
    fetchGatePass();
    
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> TRANSFER DETAILS </h1>
          </Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">TRANSFER NO. {newTransfer.transfer_number}</span>
          </Col>
        </Row>

        {/* content */}
        <div className="review-form mb-3">
          {/* TRANSACTION/PAYMENT DETAILS */}
          {type === "for_approval" && (
            <>
              <Row>
                <Col xs={12} lg={3}>
                  <Row>
                    <span className="review-label nc-modal-custom-row">
                      Transfer Slip No.
                    </span>
                  </Row>
                  <Row className="p-sides-10">
                    <Form.Control
                      type="number"
                      name="transfer_number"
                      defaultValue={newTransfer.transfer_number}
                      className="react-select-container"
                      onChange={(e) => handleDetailChange(e)}
                    />
                    <InputError
                      isValid={isError.transfer_number}
                      message={"Transfer number is required"}
                    />
                  </Row>
                </Col>
                <Col xs={12} lg={9} className="review-container py-3">
                  <Row>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          Doc No.
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.doc_no}
                        </span>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          Transfer Date
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {dateFormat(newTransfer.transfer_date)}
                        </span>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          Encoded By
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.encoded_by}
                        </span>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          Encoded On
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.encoded_on}
                        </span>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={3}>
                  <Row>
                    <span className="review-label nc-modal-custom-row">
                      Dispatcher
                    </span>
                  </Row>
                  <Row>
                    <Select
                      name="dispatcher"
                      className="react-select-container fs-6"
                      classNamePrefix="react-select"
                      placeholder="Select Dispatcher..."
                      value={employeeValue}
                      options={employeeOptions}
                      onChange={(e) => handleSelectChange(e)}
                    />
                    <InputError
                      isValid={isError.dispatcher}
                      message={"Dispatcher is required"}
                    />
                  </Row>
                </Col>
                <Col xs={12} lg={9} className="review-container py-3">
                  <Row>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          From Branch
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.branch_from_name}
                        </span>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          To Branch
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.branch_to_name}
                        </span>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <span className="review-label nc-modal-custom-row">
                          Remarks
                        </span>
                      </Row>
                      <Row>
                        <span className="review-data">
                          {newTransfer.remarks}
                        </span>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {type !== "for_approval" && type !== "completed" && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Doc Noa.
                    </span><br />
                    <span className="review-data">{newTransfer.doc_no}</span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Transfer Date
                    </span><br />
                    <span className="review-data">
                      {newTransfer.transfer_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Encoded By
                    </span><br />
                    <span className="review-data">
                      {newTransfer.encoded_by}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Encoded On
                    </span><br />
                    <span className="review-data">
                      {newTransfer.encoded_on}
                    </span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Dispatcher
                    </span><br />
                    <span className="review-data">
                      {newTransfer.dispatcher_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      From Branch
                    </span><br />
                    <span className="review-data">
                      {newTransfer.branch_from_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      To Branch
                    </span><br />
                    <span className="review-data">
                      {newTransfer.branch_to_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Remarks
                    </span><br />
                    <span className="review-data">{newTransfer.remarks}</span>
                  </Col>
                </Row>
              </Row>
            </>
          )}
          {type === "completed" && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Received Date
                    </span><br />
                    <span className="review-data">
                      {formatDate(newTransfer.received_date)}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Received By
                    </span><br />
                    <span className="review-data">
                      {newTransfer.received_by}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Transfer Date
                    </span><br />
                    <span className="review-data">
                      {newTransfer.transfer_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Encoded By
                    </span><br />
                    <span className="review-data">
                      {newTransfer.encoded_by}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3">
                    <span className="review-label nc-modal-custom-row">
                      Encoded On
                    </span><br />
                    <span className="review-data">
                      {newTransfer.encoded_on}
                    </span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Doc No.
                    </span><br />
                    <span className="review-data">{newTransfer.doc_no}</span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      From Branch
                    </span><br />
                    <span className="review-data">
                      {newTransfer.branch_from_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      To Branch
                    </span><br />
                    <span className="review-data">
                      {newTransfer.branch_to_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                    <span className="review-label nc-modal-custom-row">
                      Dispatcher
                    </span><br />
                    <span className="review-data">
                      {newTransfer.dispatcher_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-3">
                    <span className="review-label nc-modal-custom-row">
                      Remarks
                    </span><br />
                    <span className="review-data">{newTransfer.remarks}</span>
                  </Col>
                </Row>
              </Row>
            </>
          )}

          {type !== "completed" && (
            <>
              <div className="mt-4 d-flex flex-column">
                <span className="review-data mb-2">LIST OF ITEMS TRANSFERRED</span>
                <div className="review-purchased-items purchased-items">
                {type === "for_approval" && renderRequestTable()}
                  {type !== "for_approval" &&
                    type !== "completed" &&
                    renderTable()}
                </div>
              </div>
            </>
          )}

          {type === "completed" && (
            <>
            <div className="mt-4 d-flex flex-column">
              <span className="review-data mb-2">LIST OF ITEMS TRANSFERRED</span>
              <div className="review-purchased-items purchased-items">
              {renderTable()}
              </div>
            </div>
            <div className="mt-4 d-flex flex-column">
              <span className="review-data mb-2">LIST OF ITEMS RECEIVED</span>
              <div className="review-purchased-items purchased-items">
              {renderReceivedItemsTable()}
              </div>
            </div>
            </>
          )}
          <div className="mt-4 noPrint mx-3">
              <Row className="review-data mb-2">
                FILE ATTACHMENTS
              </Row>
              <Row className="">
                {
                    fileList && fileList.map((attachment) => (
                        <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                            <img src={attachment.file_url}  className="img-preview"/>
                        </Col>
                    ))
                }
                {
                    !fileList || fileList.length === 0 && 
                    <Col xs={1}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                        <img src={noDataImg} alt="no data found" className="img-preview"/>
                    </div>
                    </Col>
                }
              </Row>
            </div>
          </div>
          {type === "for_approval" && (
            <>
            <div className="d-flex justify-content-end pt-1 pb-2">
              <button
                type="button"
                className="button-secondary me-1"
                onClick={() => navigate("/transfers")}
              >
                Close
              </button>
              <button
                type="button"
                className="button-tertiary me-1"
                onClick={() => navigate("/transfers/edit/" + id + "/" + type)}
              >
                Edit
              </button>
              <button
                type="button"
                className="button-primary w-30"
                onClick={() => handleShowApprovalModal()}
              >
                Process Transfer
              </button>
            </div>
              {/* {
                (getType() === "admin" || getType() === "warehouse_manager") && (
                  <div className="d-flex justify-content-end pb-5">
                  <button
                    type="button"
                    className="button-primary w-30"
                    onClick={() => handleShowApprovalModal()}
                  >
                    Process Transfer
                  </button>
                  </div>
                )
              } */}
            </>
          )}
          {type !== "for_approval" && (
            <div className="d-flex justify-content-end pt-1 pb-5">
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleShowPrintModal}
              >
                Print
              </button>
              <button
                type="button"
                className="button-secondary"
                onClick={() => navigate("/transfers")}
              >
                Close
              </button>
            </div>
          )}
        <div className="review-form pb-5">
          {gatePassDetails.length > 0 && (
              <>
                {
                  gatePassDetails.map((data) => {
                    return (
                      <>
                        <h4 className="page-subtitle mb-2 fs-6">GATE PASS DETAILS </h4>
                        <Row className="review-container py-3">
                          <Row>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Transfer Date
                              </span><br />
                              <span className="review-data">
                                {data.transfer_date}
                              </span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Transfer Time
                              </span><br />
                              <span className="review-data">{formatTime(data.transfer_time)}</span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Branch
                              </span><br />
                              <span className="review-data">
                                {data.branch_name}
                              </span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                type
                              </span><br />
                              <span className="review-data">
                                {data.type}
                              </span>
                            </Col>
                          </Row>
                        </Row>
                        <Row className="review-container py-3">
                          <Row>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Driver
                              </span><br />
                              <span className="review-data">
                                {data.driver}
                              </span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Plate No.
                              </span><br />
                              <span className="review-data">
                                {data.plate_no}
                              </span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Customer
                              </span><br />
                              <span className="review-data">
                                {data.customer}
                              </span>
                            </Col>
                            <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                              <span className="review-label nc-modal-custom-row">
                                Delivery Personnel
                              </span><br />
                              <span className="review-data">{data.delivery_personnel}</span>
                            </Col>
                          </Row>
                        </Row>
                        <div className="mt-4 d-flex flex-column">
                          <span className="review-data mb-2">ITEMS</span>
                          <div className="review-purchased-items purchased-items">
                          {renderGatePassTable(data)}
                          </div>
                        </div>
                      </>
                    )
                  })
                }
              </>
            )
          }
        </div>
      </div>
      
      <TransferModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        page="transaction"
        handler={handlePrintPI}
      />

      <TransferModal
        show={showApprovalModal}
        hide={handleCloseApprovalModal}
        type="process"
        page="transaction"
        handler={handleApproveTransfer}
      />

      {/* PRINT VIEW */}
      <div className="print-container px-3 py-2 display-none " id="printablediv">
        <div className="text-end print-header d-flex flex-column">
          <span>TRANSFER NO. {newTransfer.transfer_number}</span>
          <span className="text-uppercase">
            {Moment(getTodayDateISO()).format("MMMM DD, yyyy")}
          </span>
        </div>
        <div className="d-flex justify-content-center py-1">
          <img src={cleanLogo} className="print-logo" />
        </div>
        <div className="print-top">
          <h5 className="print-shop-header d-flex justify-content-center">LEYTE PAPERWORLD</h5>
          <h5 className="print-shop-header d-flex justify-content-center">168 M.H. Del Pilar, Tacloban City, Leyte</h5>
          <h5 className="print-shop-header d-flex justify-content-center">(053) 325-3888 (053) 325-7088</h5>
          <h5 className="print-shop-header d-flex justify-content-center">penpaperworld@yahoo.com</h5>
          <h5 className="print-shop-header d-flex justify-content-center">TRANSFER</h5>
        </div>
        {type !== "completed" && (
          <div className="print-body mt-5">
            <>
              <Row className="review-container py-3">
                <Col>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Transfer Number:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.transfer_number}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Doc No.:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.doc_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Transfer Date:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.transfer_date}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Encoded By:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.encoded_by}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Encoded On:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.encoded_on}
                    </Col>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Dispatcher:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.dispatcher_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      From Branch:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.branch_from_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      To Branch:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.branch_to_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.remarks}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>

            <div className="mt-4 d-flex flex-column">
              <span className="review-data mb-2 nc-modal-custom-row">
                APPLIED TO THE FOLLOWING ITEMS
              </span>
              <div className="print-table">{renderRequestTable()}</div>
            </div>
            <Row className="mt-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={newTransfer.added_by_name_signature} className="print-logo" />
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={newTransfer.approved_by_name_signature} className="print-logo" alt=""/>
              </Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                    {newTransfer.added_by_name}
                  <div className="margin-underline"></div>
                  Prepared by
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {newTransfer.approved_by_name}
                  <div className="margin-underline"></div>
                  Approved by
                </Row>
              </Col>
            </Row>
            {/* <div className="print-signatures">
              <span className="text-center text-uppercase print-label fw-bold">
                {newTransfer.added_by_name}
              </span>
              <span className="text-center text-uppercase print-label">
                {newTransfer.approved_by_name}
              </span>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Prepared by</span>
              <span>Approved by</span>
            </div> */}
          </div>
        )}
        {type === "completed" && (
          <div className="print-body mt-5">
            <>
              <Row className="review-container py-3">
                <Col>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Received Date:
                    </Col>
                    <Col xs={7} className="print-data">
                      {formatDate(newTransfer.received_date)}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Received By:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.received_by_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Transfer Date:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.transfer_date}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Encoded By:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.encoded_by}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Encoded On:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.encoded_on}
                    </Col>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Doc No.:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.doc_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      From Branch:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.branch_from_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      To Branch:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.branch_to_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Dispatcher:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.dispatcher_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <Col xs={7} className="print-data">
                      {newTransfer.remarks}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>

            <div className="mt-4 d-flex flex-column">
              <span className="review-data mb-2 nc-modal-custom-row">
                LIST OF ITEMS TRANSFERRED
              </span>
              <div className="print-table">{renderTable()}</div>
            </div>

            <div className="mt-4 d-flex flex-column">
              <span className="review-data mb-2 nc-modal-custom-row">
                LIST OF ITEMS RECEIVED
              </span>
              <div className="print-table">{renderReceivedItemsTable()}</div>
            </div>
            <Row className="mt-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={newTransfer.added_by_name_signature} className="print-logo" />
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={newTransfer.approved_by_name_signature} className="print-logo" alt=""/>
              </Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                    {newTransfer.added_by_name}
                  <div className="margin-underline"></div>
                  Prepared by
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {newTransfer.approved_by_name}
                  <div className="margin-underline"></div>
                  Approved by
                </Row>
              </Col>
            </Row>
          </div>
        )}
        {gatePassDetails?.length > 0 && (
          <>
            <span className="page-subtitle mb-2">
              -------------------------------------------------------------------------------✂-----------------------------------------------------------------------------------
             </span>
            <h4 className="page-subtitle mb-2">GATE PASS DETAILS </h4>
            {
              gatePassDetails?.map((data) => {
                return (
                  <>
                  <div className="print-body mt-5">
                    <>
                      <Row className="review-container py-3">
                        <Col>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Transfer Date:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.transfer_date}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Transfer Time:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.transfer_time}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Branch:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.branch}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Type:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.type}
                            </Col>
                          </div>
                        </Col>
                        <Col>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Driver:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.driver}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Plate No.:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.plate_no}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Customer:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.customer}
                            </Col>
                          </div>
                          <div className="d-flex my-2 align-items-center">
                            <Col xs={4} className="print-label">
                              Delivery Personnel:
                            </Col>
                            <Col xs={7} className="print-data">
                              {data.delivery_personnel}
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </>

                    <div className="mt-4 d-flex flex-column">
                      <span className="review-data mb-2 nc-modal-custom-row">
                        APPLIED TO THE FOLLOWING ITEMS
                      </span>
                      <div className="print-table">{renderGatePassTable(data)}</div>
                    </div>
                  </div>
                  </>
                )
              })
            }
            </>
        )}
      </div>
      <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
        <img
            alt="example"
            style={{
            width: '100%',
            }}
            src={previewFile}
        />
        </Modal>
      <Footer/>
    </div>
  );
}
